module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_critical-784841bd5b8ab9bb084312991f27a1b0.svg";